import React from 'react';
import { ButtonsDiv, Container, FormRow, InputField } from './styles';
import Button from 'components/Buttom/Button';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useHistory } from 'react-router';

interface Props {
  setShowPopup: React.Dispatch<React.SetStateAction<boolean>>;
  setPopUpPage: React.Dispatch<React.SetStateAction<number>>;
}

const PopUpTransport = (props: Props): JSX.Element => {
  const { setPopUpPage, setShowPopup } = props;
  const history = useHistory();

  const handleSubmit = (data: any) => {
    console.log(data);
  };

  return (
    <Container>
      <header>
        <h1>Dados da viagem:</h1>
        <span>3/7</span>
      </header>
      <p>
        Atenção! A taxa de pagamento pode variar de acordo com o tipo de veículo selecionado. Consulte os valores
        <a href="">
          <strong>aqui.</strong>
        </a>
      </p>
      <Formik initialValues={{}} onSubmit={handleSubmit}>
        <Form>
          <FormRow>
            <InputField>
              <div>
                <label htmlFor="">
                  Tipo de Veículo<span>*</span>
                </label>
                <Field name="name" as="select">
                  <option value="">Selecione</option>
                  <option value="">Micro-ônibus</option>
                  <option value="">Ônibus</option>
                  <option value="">Van</option>
                </Field>
              </div>
              <ErrorMessage name="name" />
            </InputField>
            <InputField>
              <div>
                <label htmlFor="">
                  Placa<span>*</span>
                </label>
                <Field name="name" />
              </div>
              <ErrorMessage name="name" />
            </InputField>
          </FormRow>
          <FormRow>
            <InputField>
              <div>
                <label htmlFor="">
                  CNPJ<span>*</span>
                </label>
                <Field name="name" />
              </div>
              <ErrorMessage name="name" />
            </InputField>
            <InputField>
              <div>
                <label htmlFor="">
                  Cadastur<span>*</span>
                </label>
                <Field name="name" />
              </div>
              <ErrorMessage name="name" />
            </InputField>
          </FormRow>
          <FormRow>
            <InputField>
              <div>
                <label htmlFor="">
                  Nome Fantasia<span>*</span>
                </label>
                <Field name="name" />
              </div>
              <ErrorMessage name="name" />
            </InputField>
            <InputField>
              <div>
                <label htmlFor="">
                  Razão Social<span>*</span>
                </label>
                <Field name="name" />
              </div>
              <ErrorMessage name="name" />
            </InputField>
          </FormRow>
          <FormRow>
            <InputField>
              <div>
                <label htmlFor="">
                  Telefone ou Celular<span>*</span>
                </label>
                <Field name="name" />
              </div>
              <ErrorMessage name="name" />
            </InputField>
            <InputField>
              <div>
                <label htmlFor="">
                  E-mail<span>*</span>
                </label>
                <Field name="name" />
              </div>
              <ErrorMessage name="name" />
            </InputField>
          </FormRow>
        </Form>
      </Formik>
      <ButtonsDiv>
        <Button text="EDITAR" onClick={() => history.push('my-account')} />
        <Button
          text="CANCELAR"
          onClick={() => {
            setShowPopup(false);
            setPopUpPage(1);
          }}
        />
        <Button text="PRÓXIMO" onClick={() => setPopUpPage(4)} />
      </ButtonsDiv>
    </Container>
  );
};

export default PopUpTransport;
